import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output, AfterViewChecked, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SubscriptionList } from '../../shared/models/asp.types';
import { BdcDashboardState } from '../../store/bdcdashboard/bdcdashboard.reducer';
import * as fromActions from '../../store/bdcdashboard/bdcdashboard.actions';
import * as fromSelectors from '../../store/bdcdashboard/bdcdashboard.selectors';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { IAppointment, IVehicleDetails } from '@signal/asp-data-commons';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';
import { SortOrder, VehicleStatus,AppointmentStatus } from '@signal/asp-data-commons/lib/enums/enum';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import _ from 'lodash';
import { getCustomerDisplayName, getSessionTable, setSessionTable, unsubscribeSubscriptions, environment } from '../../shared/services/util.service';
import { LuxonDateAdapter } from '../../shared/services/luxon-date-adapter';
import { Clipboard } from '@angular/cdk/clipboard';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-pending-appointment',
  templateUrl: './pending-appointment.component.html',
  styleUrls: ['./pending-appointment.component.scss']
})
export class PendingAppointmentComponent implements OnInit, OnDestroy,AfterViewChecked{
  isLoading$: Observable<boolean>;
  cancel = 'overrideCapacity.cancel';
  dateFormat = 'MM-dd-yyyy';

  initColumns: any[] = [{ id: 'customerName', display: 'pendingAppointments.customerName',minWidth:162,maxWidth:320}, { id: 'contactInfo', display: 'pendingAppointments.customerContactInformation',minWidth:270,maxWidth:380},
  { id: 'model', display: 'pendingAppointments.vehicleModel', col: 'model' ,minWidth:157,maxWidth:260,width:170}, { id: 'vin', display: 'VIN', col: 'vin',minWidth:145,maxWidth:200},
  {id: 'advisor', display: 'navigation.salesAdvisor', col: 'advisor',minWidth:180,maxWidth:195},
  { id: 'appointmentCreatedDate', display: 'pendingAppointments.dateCreated', col: 'appointmentCreatedDate',minWidth:110,maxWidth:130 }, { id: 'appointmentType', display: 'pendingAppointments.appointmentType', col: 'appointmentType',minWidth:110,maxWidth:150 },
  { id: 'source', display: 'pendingAppointments.newUsed', col: 'source',minWidth:70,maxWidth:100}, { id: 'vehicleStatus', display: 'pendingAppointments.vehicleStatus', col: 'dealerCategory',minWidth:78,maxWidth:120 },
  { id: 'dealer', display: 'pendingAppointments.dealership', col: 'dealerCode',minWidth:95,maxWidth:120 },
  { id: 'linkSentOn', display: 'pendingAppointments.linkSentOn', col: 'linkSentToCustomerOn',minWidth:95,maxWidth:110 },
  { id: 'comments', display: 'pendingAppointments.comments', col: 'appointmentComments',minWidth:150,maxWidth:250 }];
  
  columnsToDisplay = [ 'actions','select', 'customerName', 'contactInfo', 'model', 'vin','advisor',
    'appointmentCreatedDate', 'appointmentType', 'source', 'vehicleStatus', 'dealer', 'linkSentOn', 'comments'];

  columnsToDisplayForFilter: any[] = ['actions','selectFilter', 'customerNameFilter', 'contactInfoFilter', 'modelFilter',
    'vinFilter', 'salesConsultantFilter','appointmentCreatedDateFilter', 'appointmentTypeFilter',
    'sourceFilter', 'vehicleStatusFilter', 'dealerFilter', 'linkSentOnFilter', 'commentsFilter'];
    
  initColumnsForFilter: any[] = [{id:'actionsFilter', display: 'deliveryChecklist.actions' },{id:'selectFilter', display :''}, {id :'customerNameFilter', display : 'pendingAppointments.customerName'},
  {id:'contactInfoFilter', display: 'pendingAppointments.customerContactInformation'},{id:'modelFilter', display: 'pendingAppointments.vehicleModel'},{id:'vinFilter', display: 'VIN'}, {id: 'salesConsultantFilter', display: 'navigation.salesAdvisor'}, {id :'appointmentCreatedDateFilter', display: 'MM-DD-YYYY'},
  {id:'appointmentTypeFilter', display: 'pendingAppointments.appointmentType'}, {id:'sourceFilter', display: 'pendingAppointments.newUsed' },
  {id:'vehicleStatusFilter', display: 'pendingAppointments.vehicleStatus' }, {id:'dealerFilter', display: 'pendingAppointments.dealership' },
  {id:'completeEditFilter', display: 'pendingAppointments.complete/Edit' }, {id:'cancelFilter', display: this.cancel },
  {id:'sendLinkFilter', display: 'pendingAppointments.sendLink' }, 
  {id:'linkSentOnFilter', display: 'MM-DD-YYYY' },
  {id:'commentsFilter', display: 'pendingAppointments.comments' } ];
  searchForm: UntypedFormGroup;
  subscriptions: SubscriptionList = {};
  allAppointmentsCount$: Observable<number>;
  filteredAppointmentsCount$: Observable<number>;
  appointments$: Observable<IAppointment[]>;
  pageSizeOptions: number[] = [20, 50, 100]
  pageIndex: number = 0;
  pageSize: number = 20;
  dataSource: any;
  allAppointments: IAppointment[];
  appointments: IAppointment[];
  dealerCode$: Observable<string>;
  dealerCode: string;
  searchValues  = [];
  isSearchLoading = false;
  sortingField : string = 'appointmentCreatedDate';
  sortOrder : string = SortOrder.ASC;
  @ViewChild(CdkVirtualScrollViewport, { static: false })
  public viewPort: CdkVirtualScrollViewport;
  @ViewChild('dragHelper') dragHelper;
  @ViewChildren('tableHead') tableHeads;
  width=113;
  selectedColumn: any;
  dragged = false;
  private _currentDragger: any;
  private _selectedColumnElement: any;
  private _startWidth: number;
  private _startX: any;
  splitChar = 0;
  @Output() public onColumnChange: EventEmitter<any> = new EventEmitter();
  lockTable=true;

  constructor(private readonly formBuilder: UntypedFormBuilder,
    public readonly BdcDashboardStateStore: Store<BdcDashboardState>,
    private readonly router: Router,
    private dealerState: Store<DealerState>,
    public readonly dialog: MatDialog,
    private readonly luxonAdapter: LuxonDateAdapter,
    private readonly copy: Clipboard,
    private readonly translate: TranslateService,
    private readonly cdref: ChangeDetectorRef
  ) { }

  ngAfterViewChecked(): void {
    if(this.lockTable && this.tableHeads?._results.length)
    {
      const sessionTable=JSON.parse(getSessionTable('PendingApptTable'));
      sessionTable?.forEach(col => {
        const column=this.tableHeads._results.filter(c=>c.nativeElement.innerText===this.translate.instant(col.column))[0];
        if(col?.width && column)
        {
          column.nativeElement.style.width = `${col?.width}`;
          if(col.column ==='VIN')
          {
            this.width = parseInt(col?.width.slice(0,-2));
            this.splitChar = -(Math.round(this.width / 10) - 4);
            this.cdref.detectChanges();
          }
        }
      });
      this.lockTable=false;
    }
  }

  ngOnInit(): void {
    this.dealerCode$ = this.dealerState.select(selectDealerCode);
    this.subscriptions.dealerCode = this.dealerCode$.subscribe(code => {
      this.dealerCode = code;
    })
    this.isLoading$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointmentsLoading);
    this.setupStore();
    this.InitializeSearchForm();
  }

  get Status() {
    return AppointmentStatus;
  }

  setupStore() {
    this.BdcDashboardStateStore.dispatch(new fromActions.LoadPendingAppointments({ type: 'pending', offset: 1, limit: this.pageSize, sortingField: this.sortingField,sortOrder: this.sortOrder }));
    this.allAppointmentsCount$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointmentsCount);
    this.filteredAppointmentsCount$ = this.BdcDashboardStateStore.select(fromSelectors.selectFilteredPendingAppointmentsCount);
    this.appointments$ = this.BdcDashboardStateStore.select(fromSelectors.selectPendingAppointments)
    this.subscriptions.vehicleData = this.appointments$.subscribe(data => {
      this.allAppointments = data;
      this.appointments = data;
      this.dataSource = new MatTableDataSource(data);
      this.isSearchLoading = false;
    });
  }

  onRecordsPerPageChange(value: number) {
    this.pageIndex = 0;
    this.pageSize = value;
    this.OnLoadNextPageData();
  }

  onPageChange(pageEvent: PageEvent) {
    this.pageIndex = pageEvent.pageIndex;
    this.OnLoadNextPageData();
  }

  OnLoadNextPageData() {
    if(this.searchValues.length > 0) {
      this.searchAppointments();
    }
    else {
      this.appointments = [];
      this.dataSource = new MatTableDataSource(this.appointments);
      this.isSearchLoading = true;
      this.BdcDashboardStateStore.dispatch(new fromActions.LoadSearchPendingAppointments({
        type: 'pending',
        offset: this.pageIndex + 1,
        limit: this.pageSize,
        sortingField: this.sortingField,
        sortOrder: this.sortOrder,
        searchConfig: {},
        isSearch: false
      }));
    }
  }
  
  InitializeSearchForm() {
    this.searchForm = this.formBuilder.group({
      customerNameFilter: [''],
      salesConsultantFilter:[''],
      contactInfoFilter: [''],
      modelFilter: [''],
      vinFilter: [''],
      appointmentCreatedDateFilter: [''],
      appointmentTypeFilter: [''],
      sourceFilter: [''],
      vehicleStatusFilter: [''],
      linkSentOnFilter: [''],
      dealerFilter: [''],
      commentsFilter: ['']
    })
  }

  isSendLinkDisabled(vehicle: IVehicleDetails) {
    return vehicle.dealerCategory === VehicleStatus.A || vehicle.dealerCategory === VehicleStatus.F 
    || vehicle.dealerCode !== this.dealerCode || vehicle.isSafetyCampaign;
  }

  editAppointment(appointment: IAppointment) {
    this.router.navigate(['asp/bdc/delivery'], {
      queryParams: {
        id: appointment.appointmentId,
        email: appointment.emailAddress,
        from: 'complete'
      }
    });
  }

  cancelAppointment($event, appointment) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'pendingAppointments.cancelConfirmation',
        popupBodyText: 'serviceSchedule.areYouSureYouWantToCancelThisAppointment',
        saveButton: 'service.yes',
        cancelButton: 'service.no'
      },
      panelClass: 'asp-modal-container'
    });
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        this.BdcDashboardStateStore.dispatch(
          new fromActions.CancelPendingAppointments({ appointment, type: 'pending', count: this.allAppointments?.length }));
      }
    });
  }

  copyLink(_$event, appointmentData){
    let env = '';
    switch(environment.env){
      case 'dev':
      case 'local':
        env = 'dev.'
        break;
      case 'qa':
        env = 'qa.'
        break;
    }
    const url = `https://${env}scheduling.toyota.com/delivery?id=${appointmentData?.appointmentId}&isFromSaved=true&dealerCd=${appointmentData?.dealerCode}&languageCd=${appointmentData?.languageId}`;
    return this.onCopyDetails(url)
  }

  sendLinkToCustomer($event, appointmentData: IAppointment) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'serviceSchedule.sendLinkToCustomer',
        popupBodyText: 'pendingAppointments.doYouWantToSendTheLinkToCustomer',
        saveButton: 'service.yes',
        cancelButton: this.cancel
      },
      panelClass: 'asp-modal-container'
    });
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {

        let appointment = {
          ...appointmentData, appointmentStartDate: 'NA', timeSlotId: 'NA',
          linkSentToCustomerOn: new Date().toISOString()
        };
        this.BdcDashboardStateStore.dispatch(
          new fromActions.SendLinkToCustomer({ appointment })
        );
      }
    });
  }

  getDisplayDate(date: string) {
    return DateTime.fromISO(date).toFormat(this.dateFormat);
  }

  getCustomerDisplayName(customer: any): string {
    return getCustomerDisplayName(customer);
  }

  getAppointmentCreatedDate(date: string) {
    return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat(this.dateFormat);
  }

  getStatus(status: string) {
    switch (status) {
      case 'A':
        return 'otherTexts.allocated';
      case 'F':
        return 'otherTexts.inTransit';
      case 'G':
        return 'otherTexts.ground';
      default:
        return status;
    }
  }

  getFormatedDate(date: string) {
    const dates= date.split(',');
    let dateArr = '';
    dates.forEach( val => {
      const replacedValue = val.trim();
      const foramteddDate = DateTime.fromFormat(replacedValue, this.dateFormat).toFormat('yyyy-MM-dd');
      if(foramteddDate && foramteddDate !== 'Invalid DateTime') {
        dateArr += (dateArr.length ? `,${foramteddDate}` : foramteddDate);
      }
    })
    return dateArr;
  }

  searchAppointments() {
    const searchData = {...this.searchForm.value};
    if(searchData.appointmentCreatedDateFilter) {
      searchData.appointmentCreatedDateFilter = this.getFormatedDate(searchData.appointmentCreatedDateFilter)
    }
    if(searchData.linkSentOnFilter) {
      searchData.linkSentOnFilter = this.getFormatedDate(searchData.linkSentOnFilter);
    } 
    this.appointments = [];
    this.dataSource = new MatTableDataSource(this.appointments);
    this.isSearchLoading = true;
    this.BdcDashboardStateStore.dispatch(new fromActions.LoadSearchPendingAppointments({ type: 'pending', offset: this.pageIndex + 1,
      limit: this.pageSize, sortingField: this.sortingField, sortOrder: this.sortOrder, searchConfig: searchData, isSearch: true}));
  }

  addSearchField(columnField, value) {
    const index = this.searchValues.findIndex(x => x?.column === columnField);
    if (index === -1 && !!value) {
      this.searchValues.push({column: columnField, colValue: value});
    } 
    else {
      value ? this.searchValues[index].colValue = value : this.searchValues.splice(index, 1);
    }
    this.searchAppointments();
  }

  onCloseFilterValue(searchColumn, index){
    this.searchValues.splice(index, 1);
    this.searchForm.get(searchColumn).patchValue('');
    this.searchAppointments();
  }

  clearFilters() {
    this.searchValues = [];
    this.InitializeSearchForm();
    this.searchAppointments();
  }

  sortChange(col: string) {
    if(this.sortingField === col) {
      this.sortOrder = this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
    }
    else {
      this.sortOrder = SortOrder.ASC;
    }
    this.sortingField = col;
    this.OnLoadNextPageData();
  }

   scrollDown() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop += 20;
  }

   scrollUp() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop -= 20;
  }
 
  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
  }

  onCopyDetails(vin: string){
    return this.copy.copy(vin);
  }

  public onDraggerClick(event) {
    this.dragHelper.nativeElement.style.display = 'none';
    event.stopPropagation();
  }

  public setHelperPosition(event) {
    const helper = this.dragHelper.nativeElement;
    helper.style.display = 'block';
    helper.style.left = `${event.x - helper.parentNode?.getBoundingClientRect().left}px`;
  }


  public toggleColumnWidth(col, event) {
    const selectedColumnForResize = this.initColumns.filter(c => c.display === col)[0];
    const selectedElement = event?.target?.parentNode;
    const elementWidth=parseInt((selectedElement?.style?.width || '0px').slice(0,-2));
    const width = (this.initColumns && (elementWidth >selectedColumnForResize?.minWidth)) ? selectedColumnForResize?.minWidth : selectedColumnForResize?.maxWidth;
    selectedElement.style.flex = `0 0 ${width}px`;
    selectedElement.style.width = `${width}px`;
    if (col === "VIN" || col === 'vin')
    {
      this.width = parseInt(width);
      this.splitChar = -(Math.round(this.width / 10) - 4);
    }
    this.selectedColumn = event?.target?.parentNode;
    this.dragged = false;
    this.onColumnChange.emit(null);
    const setting={column:col,width:`${width}px`};
    setSessionTable(setting,col,'PendingApptTable');
  }

  startResize(event, _column) {
    const col = event.source.element.nativeElement;
    this.setHelperPosition(event);
    this.dragged = true;
    this._currentDragger = col;
    this._selectedColumnElement = col.parentNode;
    this._startWidth = this._selectedColumnElement.offsetWidth;
    this.dragHelper.nativeElement.style.display = 'block';
    this._currentDragger.style.visibility = 'hidden';
    this._startX = this._currentDragger.getBoundingClientRect()['x'];
    this._selectedColumnElement.classList.add('dragged');
  }

  resizeColumn(event: any, col: any) {
    
    this.selectedColumn = event.source.element.nativeElement.parentNode;
    const selectedColumnForResize = this.initColumns.filter(c => c.display === col)[0];
    this.selectedColumn.style.maxWidth = `${selectedColumnForResize.maxWidth}px`;
    this.selectedColumn.style.minWidth = `${selectedColumnForResize.minWidth}px`;
    if (this.dragged) {
      const x = event.event.x ? event.event.x : event.pointerPosition.x ;
      const width = this._startWidth + (x - this._startX);
      if (width >= parseInt(this.selectedColumn.style.minWidth, 10) && width <= parseInt(this.selectedColumn.style.maxWidth, 10)) {
        this._selectedColumnElement.style.width = `${width}px`;
        this._selectedColumnElement.style.flex = `0 0 ${width}px`;
        this.setHelperPosition(event.event);
      }
    }
    this.setHelperPosition(event.event);
  }

  endResize(_event, col) {
    if (this.dragged) {
      this.dragged = false;
      this.selectedColumn.style['flex'] = this._selectedColumnElement.style.flex;
      this.selectedColumn.style['width']  = this._selectedColumnElement.style.width;
      this.selectedColumn.width = this._selectedColumnElement.style.width;
      if (col === "VIN" || col === "vin") {
        this.width = (parseInt(this.selectedColumn.width));
        this.splitChar = -(Math.round(this.width / 10) - 4);
        this.width = (parseInt(this.selectedColumn.width));
      }
      this._selectedColumnElement.classList.remove('dragged');
      this._selectedColumnElement = null;
      this._currentDragger.style.visibility = 'visible';
      this._currentDragger.style.transform = 'none';
      this._startX = this._startWidth = 0;
      this.onColumnChange.emit(null);
      this.initColumns.forEach(column => {
        if (column.display === col) {
          column.width = this.selectedColumn.width;
        }
      });
      const setting={column:col,width: this.selectedColumn.width};
      setSessionTable(setting,col,'PendingApptTable');
    }
    this.dragHelper.nativeElement.style.display = 'none';
  }
}
